<template>
  <div v-if="showFlag">
    <div class="modal-backdrop fade" :class="backClassNames"></div>
    <div class="progress-wrap fade" :class="barClassNames">
      <div class="progress">
        <div
          class="progress-bar border-primary progress-bar-striped progress-bar-animated"
          role="progressbar"
          aria-valuenow="100"
          aria-valuemin="0"
          aria-valuemax="100"
          style="width: 100%"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import { getters as BootstrapGetters } from "../../store/Bootstrap";

export default {
  data() {
    return {
      timer: null,
      showFlag: false,
      showClass: false
    };
  },
  computed: {
    showing() {
      return BootstrapGetters.checkLoading();
    },
    backClassNames() {
      return {
        show: this.showClass
      };
    },
    barClassNames() {
      return {
        show: this.showClass
      };
    }
  },
  watch: {
    showing: {
      immediate: true,
      handler: function(newVal) {
        if (this.timer !== null) {
          clearTimeout(this.timer);
          this.timer = null;
        }

        if (newVal) {
          this.showFlag = true;
          this.timer = setTimeout(() => {
            this.showClass = true;
          }, 10);
        } else {
          this.showClass = false;
          this.timer = setTimeout(() => {
            this.showFlag = false;
          }, 100);
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-backdrop {
  z-index: 1051;
}
.progress-wrap {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1052;
  display: flex;
  align-items: center;
  justify-content: center;
}
.progress {
  width: 90%;
  max-width: 320px;
}
</style>
